import * as React from 'react';
import { Icon } from '@blueprintjs/core';

interface Props {
    giant?: boolean;
};

interface State {};


export class DoneMarker extends React.Component<Props, State> {

    state: State = {}

    render() {
        const {
            giant
        } = this.props;

        if (giant === true) {
            return <Icon iconSize={30} icon={"tick"} style={{color: '#0d8050'}} />
        }

        return <Icon icon={"tick"} style={{color: '#0d8050'}} />
    }
}
